import React, { useState, useRef, useEffect, useCallback } from "react";
import * as APIModels from "../../../../models";
import Select, { ActionMeta } from "react-select";
import AsyncSelect from "react-select/async";
import { SubmissionService } from "../../../../services/SubmissionService";
import CaseDataInput from "../CaseDataInput";
import Parties from "../Parties";
import Pleadings from "../Pleadings";
import Fees from "../Fees";
import TylerPleadings from "../TylerPleadings";
import canSubmit from "./TylerDocumentUtils";

import NotesModal from "../modals/NotesModal";

type MyOptionType = { label: string; value: string };

export default function NewCase({
    submission,
    onSelectDocument,
    filter,
    currentDocument,
    onCaseDataChange,
}: {
    submission: APIModels.Submission;
    onSelectDocument: (doc: APIModels.Document, index: number) => void;
    filter?: string;
    currentDocument: APIModels.Document | null;
    onCaseDataChange?: (caseData: APIModels.CaseData) => void;
}) {
    const [completedSubmission, setCompletedSubmission] = useState(submission);
    const [completedDocs, setCompletedDocs] = useState(submission.documents!);
    const [completedFees, setCompletedFees] = useState(submission.fees ?? []);
    const [completedParties, setCompletedParties] = useState(
        submission.parties ?? []
    );
    const [currentCaseData, setCurrentCaseData] = useState(submission.caseData);
    const [submitting, setSubmitting] = useState(false);
    const [feeLoading, setFeeLoading] = useState(true);
    const partiesTab = React.createRef<HTMLButtonElement>();
    const [override, setOverride] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(currentDocument);
    const [notesCheck, setNotesCheck] = useState(false);
    const [lockedError, setLockedError] = useState(false);
    const [partiseHaveAnUndefinedAddress, setPartiseHaveAnUndefinedAddress] =
        useState(false);
    const [isSubmissionLocked, setIsSubmissionLocked] = useState(
        (submission.portalIdentifier == "TX" ||
            submission.portalIdentifier == "IL" ||
            submission.portalIdentifier == "IN" ||
            submission.portalIdentifier == "NC" ||
            submission.portalIdentifier == "CA" ||
            (submission.portalIdentifier == "GA" &&
                completedSubmission.caseData &&
                completedSubmission.caseData.caseTypeID !=
                    APIModels.EmptyGuid) ||
            submission.portalIdentifier == "MD") &&
            submission.documents
                ?.map(
                    (d) =>
                        d.securityID !== null ||
                        d.securityID !== undefined ||
                        d.securityID !== "" ||
                        d.securityID !== APIModels.EmptyGuid
                )
                .reduce((a, b) => a && b)
    );
    const [showNotesModal, setShowNotesModal] = useState(
        (submission.notes?.map((o, i) => o.note ?? "")?.join(" ") ?? "")
            .length > 0
    );

    useEffect(() => {
        console.log("NewCase::isSubmissionLocked", {
            "Tyler?":
                submission.portalIdentifier == "TX" ||
                submission.portalIdentifier == "IL" ||
                submission.portalIdentifier == "IN" ||
                submission.portalIdentifier == "NC" ||
                submission.portalIdentifier == "CA" ||
                (submission.portalIdentifier == "GA" &&
                    completedSubmission.caseData &&
                    completedSubmission.caseData.caseTypeID !=
                        APIModels.EmptyGuid) ||
                submission.portalIdentifier == "MD",
            notesCheck: notesCheck,
            "All Documents have securityIDS?": submission.documents
                ?.map(
                    (d) =>
                        d.securityID !== null ||
                        d.securityID !== undefined ||
                        d.securityID !== "" ||
                        d.securityID !== APIModels.EmptyGuid
                )
                .reduce((a, b) => a && b),

            submissionNotes:
                submission.notes != null &&
                submission.notes != undefined &&
                submission.notes.length > 0 &&
                submission.notes[0].note != "",
            "Submission Locked?": isSubmissionLocked,
        });
    }, [isSubmissionLocked]);

    useEffect(() => {
        setSelectedDocument(currentDocument);
    }, [currentDocument]);

    useEffect(() => console.log(completedSubmission), [completedSubmission]);

    // f4 to submit

    window.addEventListener("keydown", (event: KeyboardEvent) => {
        switch (event.code) {
            case "F1":
                event.stopPropagation();
                event.stopImmediatePropagation();
                event.cancelBubble = true;
                event.preventDefault();
                event.returnValue = false;
                (
                    document.getElementById("flush-headingOne")
                        ?.firstElementChild as HTMLButtonElement
                ).click();

                break;
            case "F2":
                event.stopPropagation();
                event.stopImmediatePropagation();
                event.cancelBubble = true;
                event.preventDefault();
                event.returnValue = false;
                (
                    document.getElementById("flush-headingTwo")
                        ?.firstElementChild as HTMLButtonElement
                ).click();
                break;
            case "F3":
                event.stopPropagation();
                event.stopImmediatePropagation();
                event.cancelBubble = true;
                event.preventDefault();
                event.returnValue = false;
                (
                    document.getElementById("flush-headingThree")
                        ?.firstElementChild as HTMLButtonElement
                ).click();
                break;
            default:
                break;
        }
    });

    const lockSubmission = (docHasSecurity: Map<string, boolean>): void => {
        console.log({ "lockSubmission Debug": docHasSecurity });
        const unlock = Array.from(docHasSecurity.values())
            .map((value, k) => {
                console.log({ "lockSubmission inMap Debug": [value, k] });
                return value;
            })
            .reduce((a, b) => a && b);
        console.log({ "lockSubmission Debug isLocked": unlock });
        setIsSubmissionLocked(!unlock);
        // set error message at the bottom of submission
    };

    const onCaseDataChangeInternal = (caseData: APIModels.CaseData) => {
        setCurrentCaseData(caseData);
        if (onCaseDataChange) {
            onCaseDataChange(caseData);
        }
    };

    const onSaveCaseData = (
        caseData: APIModels.CaseData,
        portalIdentifier: string
    ) => {
        console.log(`The division is ${caseData.division} in Parent`);
        setCompletedSubmission({
            ...completedSubmission,
            caseData: caseData,
            portalIdentifier: portalIdentifier,
        });
        setCurrentCaseData(caseData);

        if (caseData.caseSubTypeID && caseData.caseTypeID) {
            partiesTab?.current?.click();
        }
    };

    const onUpdateParties = (parties: APIModels.Party[]) => {
        setCompletedParties(parties);
    };

    const handleFeeLoading = (value: boolean) => {
        console.log({ "Handeling fees loading: ": !feeLoading });
        setFeeLoading(value);
    };

    const onUpdateDoc = (doc: APIModels.Document) => {
        const docs = [...completedDocs!];
        const index = completedDocs?.findIndex((v) => v.id == doc.id);
        // console.log("onUpdateDoc in NewCase " + JSON.stringify(docs[index!]));
        docs[index!].documentType = doc.documentType;
        docs[index!].documentGroup = doc.documentGroup;
        docs[index!].documentTypeID = doc.documentTypeID;
        docs[index!].filingCodeID = doc.filingCodeID;
        docs[index!].filingComponentID = doc.filingComponentID;
        docs[index!].securityID = doc.securityID;
        docs[index!].description = doc.description;
        docs[index!].comments = doc.comments;
        docs[index!].fees = doc.fees;
        docs[index!].optionalServices = doc.optionalServices;
        setCompletedDocs(docs);
    };

    useEffect(() => {
        setIsSubmissionLocked(fallbackSubmittable());
    }, [completedDocs]);

    const onFeeChange = (fees: APIModels.FeeType[]) => {
        setCompletedFees(fees);
    };

    // add a callback function for the loading button.

    const onTestSubmit = () => {
        console.log(completedSubmission);
    };

    const fallbackSubmittable = (): boolean => {
        const isTyler =
            submission.portalIdentifier == "TX" ||
            submission.portalIdentifier == "IL" ||
            submission.portalIdentifier == "IN" ||
            submission.portalIdentifier == "NC" ||
            submission.portalIdentifier == "CA" ||
            (submission.portalIdentifier == "GA" &&
                completedSubmission.caseData &&
                completedSubmission.caseData.caseTypeID !=
                    APIModels.EmptyGuid) ||
            submission.portalIdentifier == "MD";

        const doAllDocumentsHaveSecurity =
            completedDocs
                .map(
                    (doc) =>
                        doc.securityID !== null ||
                        doc.securityID !== undefined ||
                        doc.securityID !== "" ||
                        doc.securityID !== APIModels.EmptyGuid
                )
                .reduce((a, b) => a && b) ?? false;

        // if it is a tyler state and all documents have security
        // allow submission to be submitted

        return isTyler && doAllDocumentsHaveSecurity;
    };

    const isTyler = (): boolean =>
        submission.portalIdentifier == "TX" ||
        submission.portalIdentifier == "IL" ||
        submission.portalIdentifier == "IN" ||
        submission.portalIdentifier == "NC" ||
        submission.portalIdentifier == "CA" ||
        (submission.portalIdentifier == "GA" &&
            completedSubmission.caseData &&
            completedSubmission.caseData.caseTypeID != APIModels.EmptyGuid) ||
        submission.portalIdentifier == "MD";

    const [isSecurityRequired, setIsSecurityRequired] = useState(false);
    const [availableSecurityTypes, setAvailableSecurityTypes] = useState<
        MyOptionType[]
    >([]);
    const securityTypesRequired = (opts: MyOptionType[]) => {
        setIsSecurityRequired(opts.length !== 0);
        setAvailableSecurityTypes(opts);
        return opts.length !== 0;
    };
    const doAllDocumentsHaveSecurity = (): boolean => {
        let result;
        if (completedDocs.length === 1) {
            console.log({
                "There is only one document": {
                    securityID: completedDocs[0].securityID,
                    IsNull: completedDocs[0].securityID == null,
                    IsUndefined: completedDocs[0].securityID == undefined,
                    IsEmptyGuid:
                        completedDocs[0].securityID == APIModels.EmptyGuid,
                    IsEmptyString: completedDocs[0].securityID == "",
                },
            });
            result =
                completedDocs[0].securityID !== null &&
                completedDocs[0].securityID !== undefined &&
                completedDocs[0].securityID !== "" &&
                completedDocs[0].securityID !== APIModels.EmptyGuid;
        } else {
            result =
                completedDocs
                    .map((doc) => {
                        console.log({
                            doc: doc.id,
                            currentDocument: {
                                securityID: doc.securityID,
                                IsNull: doc.securityID === null,
                                IsUndefined: doc.securityID === undefined,
                                IsEmptyGuid:
                                    doc.securityID === APIModels.EmptyGuid,
                                IsEmptyString: doc.securityID === "",
                            },
                        });
                        return doc.securityID;
                    })
                    .map(
                        (doc) =>
                            doc !== null &&
                            doc !== undefined &&
                            doc !== "" &&
                            doc !== APIModels.EmptyGuid
                    )
                    .reduce((a, b) => a && b) ?? false;
        }
        return result;
    };

    const doesPartiesHaveUnedefinedAddress = (): boolean => {
        return false;
    };

    useEffect(() => {
        console.log({
            "Submission will need to have security types because it is a Tyler State":
                isTyler(),
        });
        console.log({
            // if it do not
            "Submission will be locked because not all documents have security types":
                !doAllDocumentsHaveSecurity(),
        });
    }, [completedDocs]);

    const onSubmit = () => {
        setSubmitting(true);
        const submittable = canSubmit(
            completedSubmission,
            availableSecurityTypes
        );
        console.log("NewCase canSubmit result:", submittable);

        if (!submittable) {
            setLockedError(true);
            setSubmitting(false);
            return;
        } else if (doesPartiesHaveUnedefinedAddress()) {
            setPartiseHaveAnUndefinedAddress(true);
            setSubmitting(false);
            return;
        } else {
            SubmissionService.submit({
                attorneyId: completedSubmission.attorneyID,
                filter: filter,
                state: submission.portalIdentifier,
                body: {
                    ...completedSubmission,
                    documents: completedDocs,
                    fees: completedFees,
                    parties: completedParties,
                    override: override,
                },
            }).then(
                (resp) => {
                    if (resp.data && resp.data.id) {
                        //show efile success
                        //setNextSubmission(resp.data);
                        window.location.href = `/efile?submissionId=${resp.data.id}&filter=${filter}`;
                    } else {
                        //TODO: Show error
                        window.location.href = "/queue";
                    }
                },
                (error) => {
                    setSubmitting(false);
                    window.location.href = "/queue";
                }
            );
        }
    };

    const onCancelNotes = () => {
        setShowNotesModal(false);
        setNotesCheck(false);
    };
    const onConfirmNotes = () => {
        setShowNotesModal(false);
        setNotesCheck(false);
    };
    return (
        <>
            <div
                className="accordion accordion-flush"
                id="accordionFlushExample"
            >
                <NotesModal
                    show={showNotesModal}
                    onCancelNotes={onCancelNotes}
                    onConfirmNotes={onConfirmNotes}
                    notes={
                        submission.notes
                            ?.map((o, i) => o.note ?? "")
                            ?.join(" ") ?? ""
                    }
                ></NotesModal>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingOne">
                        <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="true"
                            aria-controls="flush-collapseOne"
                        >
                            Case Information
                        </button>
                    </h2>
                    <div
                        id="flush-collapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="flush-headingOne"
                        data-bs-parent="#accordionFlushExample"
                    >
                        <div className="accordion-body">
                            <CaseDataInput
                                submission={completedSubmission}
                                onSaveCaseData={onSaveCaseData}
                                onCaseDataChange={onCaseDataChangeInternal}
                            />
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTwo">
                        <button
                            ref={partiesTab}
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseTwo"
                            aria-expanded="false"
                            aria-controls="flush-collapseTwo"
                            disabled={
                                !submission.caseData?.caseTypeID &&
                                !submission.caseData?.caseSubTypeID
                            }
                        >
                            Parties
                        </button>
                    </h2>
                    <div
                        id="flush-collapseTwo"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingTwo"
                        data-bs-parent="#accordionFlushExample"
                    >
                        <div className="accordion-body">
                            <Parties
                                submission={completedSubmission}
                                parties={completedParties}
                                onUpdateParties={onUpdateParties}
                                currentDocument={selectedDocument}
                            />
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingThree">
                        <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseThree"
                            aria-expanded="false"
                            aria-controls="flush-collapseThree"
                        >
                            Documents
                        </button>
                    </h2>
                    <div
                        id="flush-collapseThree"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingThree"
                        data-bs-parent="#accordionFlushExample"
                    >
                        <div className="accordion-body">
                            {submission.portalIdentifier == "TX" ||
                            submission.portalIdentifier == "IL" ||
                            submission.portalIdentifier == "NC" ||
                            submission.portalIdentifier == "CA" ||
                            (submission.portalIdentifier == "GA" &&
                                completedSubmission.caseData &&
                                completedSubmission.caseData.caseSubTypeID ===
                                    APIModels.EmptyGuid) ||
                            submission.portalIdentifier == "MD" ||
                            submission.portalIdentifier == "IN" ||
                            completedSubmission.portalIdentifier == "GO" ? (
                                //completedSubmission.portalIdentifier == "GO"
                                <TylerPleadings
                                    submission={completedSubmission}
                                    originalDocs={completedDocs}
                                    onSelectDocument={onSelectDocument}
                                    onUpdateDoc={onUpdateDoc}
                                    submissionLocked={lockSubmission}
                                    securityTypes={securityTypesRequired}
                                />
                            ) : (
                                <Pleadings
                                    submission={completedSubmission}
                                    originalDocs={completedDocs}
                                    onSelectDocument={onSelectDocument}
                                    onUpdateDoc={onUpdateDoc}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className="accordion-body">
                    {submission.portalIdentifier != "FL" &&
                    !(
                        submission.portalIdentifier == "GA" &&
                        completedSubmission.caseData &&
                        completedSubmission.caseData.caseSubTypeID ===
                            APIModels.EmptyGuid
                    ) ? (
                        //completedSubmission.portalIdentifier == "GO"
                        <></>
                    ) : (
                        <div className="accordion-item">
                            <h2
                                className="accordion-header"
                                id="flush-headingFour"
                            >
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseFour"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseFour"
                                >
                                    Fees &nbsp;
                                    {feeLoading ? (
                                        <span
                                            className="spinner-border spinner-border-sm me-1"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <></>
                                    )}
                                </button>
                            </h2>
                            <div
                                id="flush-collapseFour"
                                className="accordion-collapse collapse"
                                aria-labelledby="flush-headingFour"
                                data-bs-parent="#accordionFlushExample"
                            >
                                <div className="accordion-body">
                                    <Fees
                                        submission={completedSubmission}
                                        fees={completedFees}
                                        handleFeeLoading={handleFeeLoading}
                                        onFeeChange={onFeeChange}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="row">
                <div className="col-12" style={{ textAlign: "center" }}>
                    {submitting ? ( // if the component is loading or the document is submitting.
                        <button
                            className="btn btn-primary"
                            type="button"
                            disabled={true}
                        >
                            <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Submitting...
                        </button>
                    ) : feeLoading &&
                      !(
                          submission.portalIdentifier != "FL" &&
                          !(
                              submission.portalIdentifier == "GA" &&
                              completedSubmission.caseData &&
                              completedSubmission.caseData.caseSubTypeID ===
                                  APIModels.EmptyGuid
                          )
                      ) ? (
                        // if the component is loading or the document is submitting.
                        <button
                            className="btn btn-primary"
                            type="button"
                            disabled={true}
                        >
                            Submit
                        </button>
                    ) : (
                        <button
                            className="btn btn-primary"
                            type="button"
                            disabled={
                                submission.notes != null &&
                                submission.notes != undefined &&
                                submission.notes.length > 0 &&
                                submission.notes[0].note != "" &&
                                notesCheck == false
                            }
                            onClick={onSubmit}
                        >
                            Submit
                        </button>
                    )}
                </div>
            </div>
            {submission.notes != null &&
            submission.notes != undefined &&
            submission.notes.length > 0 &&
            submission.notes[0].note != "" ? (
                <div className="row">
                    <div
                        className="col-12 mt-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <div
                            className="form-check"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <input
                                className="form-check-input me-2"
                                id="ckNotes"
                                type="checkbox"
                                checked={notesCheck}
                                onChange={(event) =>
                                    setNotesCheck(event.currentTarget.checked)
                                }
                            />
                            <label
                                htmlFor="ckNotes"
                                className="form-check-label"
                            >
                                Notes Acknowledgment
                            </label>
                        </div>
                    </div>

                    <div
                        className="col-12 mt-3"
                        style={{ textAlign: "center" }}
                    >
                        <button
                            className="btn btn-primary"
                            type="button"
                            onClick={() => {
                                setShowNotesModal(true);
                                setNotesCheck(false);
                            }}
                        >
                            Check Notes
                        </button>
                    </div>
                </div>
            ) : (
                <></>
            )}
            <div className="row mt-2">
                <div
                    className="col-12"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div
                        className="col-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                id="ckOverride"
                                type="checkbox"
                                checked={override ?? false}
                                onChange={(event) =>
                                    setOverride(event.currentTarget.checked)
                                }
                            />
                            <label
                                className="form-check-label"
                                htmlFor="ckOverride"
                            >
                                Override
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            {lockedError ? (
                <div className="row mt-2">
                    <div
                        className="col-12"
                        style={{ textAlign: "center", color: "red" }}
                    >
                        This submission cannot be submitted, until you ensure
                        that every document in the case has: a Filing Code, a
                        FilingComponent Code, and a Security Type.
                    </div>
                </div>
            ) : (
                <></>
            )}
            {partiseHaveAnUndefinedAddress ? (
                <div className="row mt-2">
                    <div
                        className="col-12"
                        style={{ textAlign: "center", color: "red" }}
                    >
                        This submission cannot be submitted, until you ensure
                        that every saved party in the case has a Stret Address.
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}
